<template>
  <div class="container">
    <el-row>
      <el-col :span="2">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="22">
        <table>
          <tr>
            <td colspan="11">检测结果/数据</td>
          </tr>
          <tr>
            <td>仪器名称</td>
            <td>{{ form.yqmc1 }}</td>
            <td>仪器编号</td>
            <td>{{ form.yqbh1 }}</td>
            <td>校准有效期</td>
            <td colspan="6">{{ form.jzyxq1 }}</td>
          </tr>
          <tr>
            <td>仪器名称</td>
            <td>{{ form.yqmc2 }}</td>
            <td>仪器编号</td>
            <td>{{ form.yqbh2 }}</td>
            <td>校准有效期</td>
            <td colspan="6">{{ form.jzyxq2 }}</td>
          </tr>
          <tr>
            <td>环境温度（℃）</td>
            <td>{{ form.hjwd }}</td>
            <td>环境湿度（%RH)</td>
            <td colspan="8">{{ form.hjsd }}</td>
          </tr>
          <tr>
            <td>被检测设备名称</td>
            <td>{{ form.bjcsbmc }}</td>
            <td>额定电压(V)</td>
            <td colspan="8">{{ form.eddy }}</td>
          </tr>
          <tr>
            <td rowspan="3">序号</td>
            <td rowspan="3">检测地点</td>
            <td rowspan="3">型号规格</td>
            <td rowspan="3">额定动作电流</td>
            <td colspan="6">动作时间(ms)</td>
            <td rowspan="3">检测结果</td>
          </tr>
          <tr>
            <td colspan="2">*1/2</td>
            <td colspan="2">*1</td>
            <td colspan="2">*5</td>
          </tr>
          <tr>
            <td>*0°</td>
            <td>*180°</td>
            <td>*0°</td>
            <td>*180°</td>
            <td>*0°</td>
            <td>*180°</td>
          </tr>
          <template v-for="(item,i) in tableData">
            <tr :key="i">
              <td>{{ item.id }}</td>
              <td>{{ item.jcdd }}</td>
              <td>{{ item.xhgg }}</td>
              <td>{{ item.eddzdl }}</td>
              <td>{{ item.dzsj_12_0 }}</td>
              <td>{{ item.dzsj_12_180 }}</td>
              <td>{{ item.dzsj_1_0 }}</td>
              <td>{{ item.dzsj_1_180 }}</td>
              <td>{{ item.dzsj_5_0 }}</td>
              <td>{{ item.dzsj_5_180 }}</td>
              <td>{{ item.jcjg }}</td>
            </tr>
          </template>
        </table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      rr_type: 'report',
      tableData: [],
      form: {
        yqmc1: '',
        yqbh1: '',
        jzyxq1: '',
        yqmc2: '',
        yqbh2: '',
        jzyxq2: '',
        hjwd: '',
        hjsd: '',
        bjcsbmc: '',
        eddy: ''
      }
    }
  },
  methods: {
    async getForm() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
        }
        let res = await this.$Api.get("record_cma_sydl1", {params: params});
        if (res) {
          this.form = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getList() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("record_cma_sydl", {params: params});
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.getForm()
    this.getList()
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>

